import { differenceInMonths } from "date-fns";

export function checkCardIsAboutToExpire(year: number, month: number): boolean {
    const expireDate = new Date(year, month - 1, 1);

    const today = new Date();
    const isInTwoMonths = differenceInMonths(expireDate, today) < 3;

    return isInTwoMonths;
}
